module.exports = "<p>\n  chits-reports works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/chits-reports/chits-reports.component.html
// module id = ./src/app/reports/chits-reports/chits-reports.component.html
// module chunks = main